import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, bool_type, option_type, int32_type, unit_type, string_type, class_type, list_type, union_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { UserManagement_UserInfo_$reflection, UserManagement_UserManagedRole_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { Remote$1, Remote$1_$reflection, GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { FormField__get_IsValid, FormField_InitWithDefault_74789EBD, ValidationRule, FormField_Init_Z1F39563A, FormField_$reflection } from "../../../../Bfs.Web.Portale/Validation.fs.js";
import { empty } from "../../../fable_modules/fable-library-js.4.19.0/List.js";

export class Page extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["UserList"];
    }
}

export function Page_$reflection() {
    return union_type("Usermanagement.Types.Page", [], Page, () => [[]]);
}

export class EditUserDialogMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["InitDialog", "LoadUserManagedRoles", "UserManagedRolesLoaded", "LoginChanged", "EmailChanged", "NameChanged", "ToggleRole", "Cancel", "Save", "Saved", "Updated"];
    }
}

export function EditUserDialogMsg_$reflection() {
    return union_type("Usermanagement.Types.EditUserDialogMsg", [], EditUserDialogMsg, () => [[], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(UserManagement_UserManagedRole_$reflection()), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", list_type(UserManagement_UserManagedRole_$reflection())]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", UserManagement_UserManagedRole_$reflection()]], [], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]]), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]]), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]], [["ErrorValue", class_type("System.Exception")]]])]]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadUserList", "UserListLoaded", "EnableUser", "DisableUser", "UserEnabledChanged", "ResetPassword", "ResetPasswordConfirmed", "ResetPasswordSubmitted", "DeleteUser", "DeleteUserConfirmed", "UserDeleted", "DialogMsg", "CreateNewUser", "EditUserRoles", "GlobalMsg"];
    }
}

export function Msg_$reflection() {
    return union_type("Usermanagement.Types.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(UserManagement_UserInfo_$reflection()), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", list_type(UserManagement_UserInfo_$reflection())]], [["ErrorValue", class_type("System.Exception")]]])]], [["id", int32_type]], [["id", int32_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Fetch.Types.Response"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("Fetch.Types.Response")]], [["ErrorValue", class_type("System.Exception")]]])]], [["userInfo", UserManagement_UserInfo_$reflection()]], [["userInfo", UserManagement_UserInfo_$reflection()]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]]), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", UserManagement_UserInfo_$reflection()]], [["id", int32_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]]), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", EditUserDialogMsg_$reflection()]], [], [["userInfo", UserManagement_UserInfo_$reflection()]], [["Item", GlobalMsg_$reflection()]]]);
}

export class UserEditModel extends Record {
    constructor(Id, Login, Email, Name, IsDirty, Sending, UserRoles, AllUsermanagedRoles, IsCurrentUser) {
        super();
        this.Id = Id;
        this.Login = Login;
        this.Email = Email;
        this.Name = Name;
        this.IsDirty = IsDirty;
        this.Sending = Sending;
        this.UserRoles = UserRoles;
        this.AllUsermanagedRoles = AllUsermanagedRoles;
        this.IsCurrentUser = IsCurrentUser;
    }
}

export function UserEditModel_$reflection() {
    return record_type("Usermanagement.Types.UserEditModel", [], UserEditModel, () => [["Id", option_type(int32_type)], ["Login", FormField_$reflection()], ["Email", FormField_$reflection()], ["Name", FormField_$reflection()], ["IsDirty", bool_type], ["Sending", bool_type], ["UserRoles", list_type(UserManagement_UserManagedRole_$reflection())], ["AllUsermanagedRoles", Remote$1_$reflection(list_type(UserManagement_UserManagedRole_$reflection()))], ["IsCurrentUser", bool_type]]);
}

export function UserEditModel_InitNew() {
    return new UserEditModel(undefined, FormField_Init_Z1F39563A(new ValidationRule(0, [])), FormField_Init_Z1F39563A(new ValidationRule(5, [])), FormField_Init_Z1F39563A(new ValidationRule(0, [])), false, false, empty(), new Remote$1(1, []), false);
}

export function UserEditModel_InitExisting_Z2556A9EA(userInfo) {
    return new UserEditModel(userInfo.KundenportalBenutzerId, FormField_InitWithDefault_74789EBD(new ValidationRule(0, []), userInfo.Login), FormField_InitWithDefault_74789EBD(undefined, userInfo.Email), FormField_InitWithDefault_74789EBD(new ValidationRule(0, []), userInfo.Name), false, false, userInfo.BenutzerverwalteteRollen, new Remote$1(1, []), userInfo.IsCurrentUser);
}

export function UserEditModel__get_CanSubmit(x) {
    if (FormField__get_IsValid(x.Email)) {
        return FormField__get_IsValid(x.Name);
    }
    else {
        return false;
    }
}

export class Model extends Record {
    constructor(Users, ActiveUserDialog) {
        super();
        this.Users = Users;
        this.ActiveUserDialog = ActiveUserDialog;
    }
}

export function Model_$reflection() {
    return record_type("Usermanagement.Types.Model", [], Model, () => [["Users", Remote$1_$reflection(list_type(UserManagement_UserInfo_$reflection()))], ["ActiveUserDialog", option_type(UserEditModel_$reflection())]]);
}

export function Model_get_Init() {
    return new Model(new Remote$1(1, []), undefined);
}

//# sourceMappingURL=Types.fs.js.map
